// a downward pointing arrow, downArrow

export const discountArrow = `<svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 32">
<path d="M0.84 4.878l26.293 26.282c1.114 1.114 2.925 1.114 4.039 0l26.293-26.288c1.114-1.114 1.114-2.925 0-4.039-0.56-0.554-1.291-0.834-2.016-0.834-0.737 0-1.462 0.28-2.022 0.834l-24.277 24.266-24.271-24.266c-0.56-0.554-1.291-0.834-2.022-0.834s-1.457 0.28-2.016 0.834c-1.114 1.12-1.114 2.925 0 4.044z"></path>
</svg>`;
